import {
  CustomerData,
  WidgetState,
  useWidgetCustomerData,
  useWidgetIsReady,
  useWidgetState,
} from "@livechat/widget-react";

type ILiveChatWidgetCallArgValue = string | number | boolean;

declare const window: Window & {
  LiveChatWidget?: {
    call: (name: string, args?: Record<string, ILiveChatWidgetCallArgValue> | string) => void;
    on: (name: "ready", callback: VoidFunction) => void;
  };
  LC_API?: {
    on_chat_ended: () => void;
  };
};

const callIfAvailable = (callback: () => void): void => {
  if (window.LiveChatWidget) {
    callback();
  }
};
const changeSessionVariables = (variables: Record<string, ILiveChatWidgetCallArgValue>, overwrite: boolean): void => {
  const setter = overwrite ? "set_session_variables" : "update_session_variables";
  callIfAvailable(() => window.LiveChatWidget?.call(setter, variables));
};
const setOnReadyCallback = (callback: VoidFunction): void => {
  callIfAvailable(() => window.LiveChatWidget?.on("ready", callback));
};
const maximize = (): void => callIfAvailable(() => window.LiveChatWidget?.call("maximize"));
const minimize = (): void => callIfAvailable(() => window.LiveChatWidget?.call("minimize"));
const hide = (): void => callIfAvailable(() => window.LiveChatWidget?.call("hide"));
const destroy = (): void => callIfAvailable(() => window.LiveChatWidget?.call("destroy"));

interface IUserChatWidget {
  widgetIsReady: boolean;
  widgetState: WidgetState | null;
  customerData: CustomerData | null;
  setSessionVariables: (variables: Record<string, ILiveChatWidgetCallArgValue>) => void;
  updateSessionVariables: (variables: Record<string, string>) => void;
  openChatWidget: VoidFunction;
  closeChatWidget: VoidFunction;
  hideChatWidget: VoidFunction;
  destroyChatWidget: VoidFunction;
  setEndChatCallback: (callback: VoidFunction) => void;
  setOnReadyCallback: (callback: VoidFunction) => void;
}

export const useChatWidget = (): IUserChatWidget => ({
  widgetIsReady: useWidgetIsReady(),
  widgetState: useWidgetState(),
  customerData: useWidgetCustomerData(),
  setSessionVariables: variables => changeSessionVariables(variables, true),
  updateSessionVariables: variables => changeSessionVariables(variables, false),
  openChatWidget: maximize,
  closeChatWidget: minimize,
  hideChatWidget: hide,
  destroyChatWidget: destroy,
  setEndChatCallback: (callback): void => {
    if (window.LC_API) {
      window.LC_API.on_chat_ended = callback;
    }
  },
  setOnReadyCallback: setOnReadyCallback,
});
